<template>
  <v-container fluid>
    <v-dialog v-model="createTemplateMessageDialog" width="500">
      <v-card class="border-radius-standard">
        <v-card-title class="headline" primary-title style="font-size: 28px">
          {{
            selected && selected.length && selected.length === 1
              ? "Rename TemplateMessage"
              : "Create New Template Message"
          }}
          <v-spacer />
          <v-icon @click="createTemplateMessageDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-template-message
            ref="addTemplateMessage"
            :put="
              selected && selected.length && selected.length === 1
                ? selected[0]
                : null
            "
            @loading="addButtonLoader = $event"
            @success="handleCreateSuccess"
          >
            <label
              slot="before-name"
              class="black--text"
              style="font-size: 16px"
              >Template Name</label
            >
            <label
              slot="before-category"
              class="black--text"
              style="font-size: 16px"
              >Category</label
            >
            <label
              slot="before-language"
              class="black--text"
              style="font-size: 16px"
              >Language</label
            >
            <label slot="before-app" class="black--text" style="font-size: 16px"
              >WhatsApp Phone Number</label
            >
          </add-template-message>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="createTemplateMessageDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading="addButtonLoader"
            color="primary"
            @click="addNewTemplateMessage"
          >
            {{
              selected && selected.length && selected.length === 1
                ? "Rename"
                : "Create"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteTemplateMessageDialog" width="400">
      <v-card v-if="selected && selected.length" class="border-radius-standard">
        <v-card-title class="headline" primary-title>
          Delete
          {{
            selected.map((templatemessage) => templatemessage.name).join(", ")
          }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this TemplateMessage?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="black"
            outline
            @click="deleteTemplateMessageDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="addButtonLoader"
            color="error"
            @click="deleteTemplateMessages"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <h1>Template Messages</h1>
      <v-spacer />
    </v-layout>
    <v-flex xs12> </v-flex>
    <v-flex xs12>
      <v-card class="card-curvey">
        <v-layout row wrap>
          <v-flex xs4>
            <v-text-field
              v-model="queries.q"
              placeholder="Search by Name, Whatsapp or State.."
              templatemessageend-icon="search"
              outline
            />
          </v-flex>
          <v-spacer />
          <v-btn
            :loading="!!(addButtonLoader && !selected.length)"
            color="blue-grey"
            class="nlp-nav-btn"
            small
            outline
            @click="syncTemplateMessages"
          >
            <v-icon>sync</v-icon>
            Sync
          </v-btn>
          <v-btn
            :loading="!!(addButtonLoader && !selected.length)"
            color="blue-grey"
            class="nlp-nav-btn"
            small
            outline
            @click="openAddDialog(true)"
          >
            <v-icon>add</v-icon>
            New Template Message
          </v-btn>
        </v-layout>

        <v-flex xs12 v-if="templateSettings && templateSettings.categories">
          <v-data-table
            :headers="headers"
            :items="queriedTemplateMessages"
            item-key="name"
            no-data-text="No Template Messages Available"
            class="elevation-1 nlp-data-table"
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.index === 0 && !props.item.name"
                class="text-center"
                style="width: 100%"
              >
                <td />
                <td />
                <td />
                <td class="text-center">No Template Messages Available</td>
                <td />
                <td />
              </tr>
              <tr v-if="props.item.name">
                <td>
                  <span
                    class="black--text pointer-cursor"
                    @click="selectTemplateMessage(props.item)"
                  >
                    {{ props.item.name }}
                    <br />
                  </span>
                  <small style="color: #1c2b33a6; text-transform: capitalize">{{
                    getTemplateMessageCategoryDisplayName(props.item.category)
                  }}</small>
                </td>
                <td class="text-center" style="text-transform: capitalize">
                  {{ props.item.app ? props.item.app.phone_number : "-" }}
                </td>
                <td class="text-center">
                  <span v-if="props.item._id">
                    {{ props.item._id }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td
                  :class="
                    setTextColor(getTemplateMessageStatus(props.item.status))
                  "
                  style="text-transform: capitalize; text-align: center"
                >
                  {{
                    getTemplateMessageStatus(props.item.status).toLowerCase()
                  }}
                  -
                  <span
                    :class="
                      setTextColor(getTemplateMessageScore(props.item.quality))
                    "
                  >
                    {{ getTemplateMessageScore(props.item.quality) }}
                  </span>
                </td>
                <td class="text-center">
                  {{
                    templateSettings.languages.filter(
                      (i) => i.code === props.item.lang
                    )[0].lang
                  }}
                  <br />
                  <span class="grey--text text--darken-1">{{
                    getComponentBody(props.item.components)
                  }}</span>
                </td>

                <td
                  style="
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    padding-right: 0 !important;
                  "
                >
                  <v-tooltip
                    bottom
                    v-if="
                      getTemplateMessageStatus(props.item.status) !==
                        'APPROVED' &&
                      getTemplateMessageStatus(props.item.status) !== 'PENDING'
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="px-3 templatemessages-small-actions-btn"
                        :to="`/campaigns/template-messages/${props.item._id}/editor`"
                      >
                        <v-icon class="template-message-small-action-icon"
                          >edit</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    v-if="
                      getTemplateMessageStatus(props.item.status) ===
                        'APPROVED' ||
                      getTemplateMessageStatus(props.item.status) === 'PENDING'
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        :to="`/campaigns/template-messages/${props.item._id}/editor`"
                        class="px-3 templatemessages-small-actions-btn"
                      >
                        <v-icon class="template-message-small-action-icon"
                          >remove_red_eye</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="px-3 templatemessages-small-actions-btn"
                        @click="initDeleteTemplateMessage(props.item)"
                      >
                        <span
                          class="botter-trash-icon template-message-small-action-bot-icon"
                          style="color: #7f7f7f"
                        />
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import AddTemplateMessage from "@/components/campaign-manager/template-messages-crud/AddTemplateMessage.vue";
export default {
  name: "TemplateMessageList",
  components: {
    AddTemplateMessage,
  },
  data() {
    return {
      queries: {
        q: "",
      },
      createTemplateMessageDialog: false,
      deleteTemplateMessageDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        {
          text: "Template Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Phone Number",
          value: "app",
          align: "center",
          sortable: false,
        },
        {
          text: "Template ID",
          value: "_id",
          align: "center",
          sortable: false,
        },
        {
          text: "Status - Quality",
          value: "status",
          align: "center",
          sortable: false,
        },
        {
          text: "Language",
          value: "actions",
          align: "center",
          sortable: false,
        },
        { text: "Actions", value: "actions", align: "right", sortable: false },
      ],
    };
  },
  computed: {
    queriedTemplateMessages() {
      return this.$store.getters["templatemessages/query"](this.queries.q);
    },
    templateSettings() {
      return this.$store.state.campaigns.templateMessageSettings;
    },
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if (val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]];
        }
      },
    },
  },
  async mounted() {
    // get templatemessages
    await this.getTemplateMessages();
    if (this.$route.query.cb && this.$route.query.cb === "add") {
      this.openAddDialog(true);
    }
  },
  methods: {
    async getTemplateMessages() {
      await this.$store.dispatch("templatemessages/sync", false);
      await this.$store.dispatch("templatemessages/get", null);
      await this.$store.dispatch("templatesettings/get", null);
    },
    openAddDialog(reset = true) {
      if (reset) this.selected = [];
      this.createTemplateMessageDialog = true;
    },
    addNewTemplateMessage() {
      if (this.$refs.addTemplateMessage) this.$refs.addTemplateMessage.submit();
    },
    initEditTemplateMessage(templatemessage) {
      this.selected = [templatemessage];
      this.openAddDialog(false);
    },
    initCopyTemplateMessage(templatemessage) {
      const inits = this.$_.pick(templatemessage, ["app"]);
      this.openAddDialog(true);
      setTimeout(() => {
        this.$root.$emit("add-templatemessage-inits", inits);
      }, 500);
    },
    selectTemplateMessage(templatemessage) {
      this.$store.dispatch("templatemessages/select", templatemessage);
      this.$router.push(
        `/campaigns/template-messages/${templatemessage._id}/editor`
      );
    },
    initDeleteTemplateMessage(templatemessage) {
      this.selected = [templatemessage];
      this.deleteTemplateMessageDialog = true;
    },
    getPreview(components) {
      let result = components
        .map((i) => (i.text ? `${i.text},` : ""))
        .join(" ");
      if (result && result.length && result.length > 30) {
        return `${result.slice(0, 30)}...`;
      } else if (result && result.length) {
        return result;
      } else return "";
    },
    handleCreateSuccess(event) {
      this.createTemplateMessageDialog = false;
      this.$router.push(`/campaigns/template-messages/${event._id}/editor`);
    },
    async deleteTemplateMessages() {
      this.$store.dispatch("setLoader", true);
      await this.$store.dispatch(
        "templatemessages/delete/single",
        this.selected[0]._id
      );

      this.deleteTemplateMessageDialog = false;

      this.$store.dispatch("setSnackbar", {
        text: `Deleted Successfully`,
        color: "success",
      });
      this.selected = [];
    },
    getTemplateMessageCategoryDisplayName(category) {
      let categoryValue;
      if (Array.isArray(category)) {
        categoryValue = category[0].value;
      } else {
        categoryValue = category;
      }
      let displayName = this.templateSettings.categories.filter(
        (i) => i.slug === categoryValue
      );

      return displayName.length
        ? displayName[0].displayName.toLowerCase()
        : category;
    },
    setTextColor(value) {
      let classes = [];
      switch (value.toLowerCase()) {
        case "draft":
          classes.push("purple--text");
          break;
        case "approved":
          classes.push("green--text");
          break;
        case "pending":
          classes.push("yellow--text text--darken-4");
          break;
        case "rejected":
          classes.push("red--text");
          break;
        case "deleted":
          classes.push("red--text");
          break;
        case "pending_deletion":
          classes.push("red--text");
          break;
        case "limit_exceeded":
          classes.push("red--text");
          break;
        case "disabled":
          classes.push("red--text");
          break;
        case "unknown":
          classes.push("black--text");
          break;
      }
      return classes;
    },
    getComponentBody(components) {
      const maxLength = 50; // Change this to the desired maximum length
      let bodyComp = components.find((el) => el.type.toLowerCase() == "body");
      if (bodyComp) {
        if (bodyComp.text.length > maxLength) {
          return bodyComp.text.slice(0, maxLength) + "...";
        } else {
          return bodyComp.text;
        }
      } else {
        return "";
      }
    },
    getTemplateMessageStatus(status) {
      if (Array.isArray(status)) {
        return status[0].value;
      } else {
        return status;
      }
    },
    getTemplateMessageScore(quality) {
      if (quality && Array.isArray(quality)) {
        return quality[0].score;
      } else {
        return quality || "";
      }
    },
    async syncTemplateMessages() {
      await this.$store.dispatch("templatemessages/sync", true);
      await this.$store.dispatch("templatemessages/get", null);
    },
  },
};
</script>

<style lang="scss" src="@/assets/sass/commponents/nlp.scss" />
<style lang="scss">
.templatemessages-small-actions-btn {
  height: 24px;
  width: 24px;
  max-width: 24px;
  min-width: 24px;
  border-radius: 3px !important;
  margin-left: 2px;
}
.template-message-small-action-icon {
  font-size: 16px !important;
  margin-left: 4px;
  color: #7f7f7f !important;
}
.template-message-small-action-bot-icon {
  font-size: 16px !important;
}
</style>
